import IconFont from '@meitu/xdesign-icon-font';
import './effect-item.less';
import React from 'react';

interface IEffectItemProps {
    title: string;
    handleClick: Function;
    iconName: string;
    noBorderBottom?: boolean;
}

const EffectItem: React.FC<IEffectItemProps> = ({ title, iconName, handleClick, noBorderBottom = false }) => {
    return (
        <div
            className="c-effect-item"
            style={{
                borderBottom: `${
                    noBorderBottom ? '1px solid rgba(0,0,0,0)' : '1px solid var(--stroke-system-separator)'
                }`,
            }}
        >
            <div className="left">
                <IconFont name={iconName} fontSize={16} />
                <span className="wrap-title">{title}</span>
            </div>
            <div className="right">
                <div className="icon" onClick={() => handleClick()}>
                    <IconFont name="PlusCircle" fontSize={20} />
                </div>
            </div>
        </div>
    );
};

export default EffectItem;

interface IEffectItemShowTitleProps {
    title: string;
    handleVisibleClick: Function;
    iconName: string;
    visible: boolean;
    handleDelClick: Function;
}

export const EffectItemShowTitle: React.FC<IEffectItemShowTitleProps> = ({
    title,
    iconName,
    handleVisibleClick,
    handleDelClick,
    visible,
}) => {
    return (
        <div className="c-effect-item show">
            <div className="left">
                <IconFont name={iconName} fontSize={16} />
                <span className="wrap-title">{title}</span>
            </div>
            <div className="right">
                {visible ? (
                    <div className="icon" onClick={() => handleVisibleClick()}>
                        <IconFont name="VisibleBold" fontSize={14} />
                    </div>
                ) : (
                    <div className="icon" onClick={() => handleVisibleClick()}>
                        <IconFont name="InvisibleBold" fontSize={14} />
                    </div>
                )}
                <div className="icon" onClick={() => handleDelClick()}>
                    <IconFont name="TrashCanBold" fontSize={14} />
                </div>
            </div>
        </div>
    );
};
